import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { LANGUAGE_LIST } from "../shared/language.constants";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpService } from "./../services/http.service";
import { StateService } from "./../services/state.service";
import { landingPageContent } from "./landing";
@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.scss"],
})
export class LandingComponent implements OnInit, AfterViewInit {
  @Input() control!: AbstractControl;

  @ViewChild("typewriterContainerDiv") typewriterContainerDivRef!: ElementRef;
  // @ViewChild('mainFirstLineDiv') mainFirstLineDivRef!: ElementRef;

  custom!: FormGroup;
  errors: any = {
    email: [
      {
        key: "required",
        message: "LANDING.VALIDATION.PLEASE_ENTER_VALID_EMAIL_ID",
      },
    ],
    zone: [
      {
        key: "required",
        message: "LANDING.VALIDATION.PLEASE_CHOOSE_ZONE",
      },
    ],
  };

  isScheduleMeetSubmitted = false;
  isDomainchk = false;
  isBottom!: boolean;
  zonelist = [
    {
      name: "",
      id: "",
    },
  ];
  email = "";
  emailId = "";
  selectedZone = "";

  isNewsletter = false;
  newsletterMessage = "";
  errorMessage = "";
  isErrorMsg = false;
  isSuccessMessage = false;
  successMessage = "";

  // set up text to print, each item in array is new line
  aText = new Array(
    "leveraging AI analytics and robust data",
    "for clustering, assortment and planograms",
    "adaptable to your needs",
    // 'adaptable to your needs and something more...',
    "to maximize retailer's incremental revenue and improve the shopper experience"
  );
  iSpeed = 10; // less time delay able to read better
  delayInMs!: number;
  firstTime = true;

  animationMs = 4000;
  animationDurationMs = 4000;

  iIndex = 0; // start printing array at this posision
  iArrLength = this.aText[0].length; // the length of the text array
  iTextPos = 0; // initialise text position

  // mainAnimationMs = 0;
  // typingAnimationMs = 0;
  // offsetMs = 0;
  // typewriterFirstTime = true;

  isActive = true;
  delay = 6000;
  groups = new Array(".hg-1", ".hg-2", ".hg-3", ".hg-4");
  animationIndex = 0;
  domainType: string = "";
  languageList = LANGUAGE_LIST;
  selectedLanguageCode = "en";
  selectedLanguage = "EN";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private httpService: HttpService,
    private stateService: StateService,
    private formBuilder: FormBuilder,
    public translate: TranslateService
  ) {
    this.domainType = this.stateService.checkAppConfig();
  }

  @HostListener("window:scroll", [])
  onScroll(): void {
    if (window.innerHeight + window.scrollY > document.body.offsetHeight) {
      this.isBottom = true;
    } else {
      this.isBottom = false;
    }
  }

  @HostListener("document:click", ["$event"])
  clickout(event: any) {
    let selection = window.getSelection();
    if (event.target.nodeName === "IMG")
      if (selection) {
        selection.removeAllRanges();
      }
  }

  selectedFaq: number = -1;
  allTeam = [
    {
      id: 1,
      proflie_image: "https://cdn.catexpert.ab-inbev.com/assets/images/felipe_aragao.png",
      name: "Felipe Aragao",
      role: "Global VP, Analytics",
    },

    {
      id: 2,
      proflie_image: "https://cdn.catexpert.ab-inbev.com/assets/images/anthony_berry_1.png",
      name: "Anthony Berry",
      role: "Global VP Key Acc. & Category Mgmt.",
    },
    {
      id: 3,
      proflie_image: "https://cdn.catexpert.ab-inbev.com/assets/images/sajith_kurup.png",
      name: "Sajith Kurup",
      role: "Global Director, Analytics",
    },
    {
      id: 4,
      proflie_image: "https://cdn.catexpert.ab-inbev.com/assets/images/santiago_1.png",
      name: "Santiago Di Ció",
      role: "Global Dir. Key Acc. & Category Mgmt",
    },
    {
      id: 5,
      proflie_image: "https://cdn.catexpert.ab-inbev.com/assets/images/wall.png",
      name: "Product Team",
      role: "",
    },
  ];

  bannerContent = landingPageContent.catexpertBannerContent;
  allFeature = landingPageContent.catexpertFeatures;
  allFaq = landingPageContent.catexpertFaq;

  continueToLogin() {
    window.open(`/login`, "_blank");
  }

  scrollToElement($ele: any): void {
    $ele.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }

  setFaq(index: number) {
    this.selectedFaq = this.selectedFaq == index ? -1 : index;
  }

  ngOnInit(): void {
    this.initializeLanguage();
    this.startBannerTextAnimation();
    this.Zone();
    this.custom = this.formBuilder.group({
      email: new FormControl(null, [Validators.required]),
      zone: new FormControl(null, [Validators.required]),
    });
  }

  ngAfterViewInit() {
    if (this.firstTime) {
      this.typewriterContainerDivRef.nativeElement.addEventListener(
        "animationstart",
        () => {
          this.firstTime = false;
        },
        false
      );
    }
  }

  //zone list
  Zone() {
    const url =
      this.domainType !== "pho"
        ? `${this.stateService.apiList.admin.zones}`
        : `${this.stateService.apiList.projects.zone}`;
    this.httpService.getZone(url).subscribe(
      (val) => {
        this.zonelist = val.body;
      },
      (err) => {}
    );
  }

  //newsletter
  Subscribe() {
    if (this.email == "") {
      this.isErrorMsg = true;
      this.errorMessage = "LANDING.VALIDATION.PLEASE_ENTER_EMAIL";
      return;
    }
    const url = `${this.stateService.apiList.user.newsletter}`;
    const data = {
      email: this.email,
    };
    this.stateService.addCalledApi(url);
    this.httpService.postNewsletter(url, data).subscribe(
      (val) => {
        if (val.status == "200") {
          this.newsletterMessage = "LANDING.MESSAGES.NEWSLETTER_SUBSCRIBED";
        }
        this.stateService.removeCalledApi(url);
        this.isNewsletter = true;
        this.isErrorMsg = false;
      },
      (err) => {
        this.isErrorMsg = true;
        this.errorMessage = err.error.message;
        this.stateService.removeCalledApi(url);
      }
    );
  }

  //newsletter
  Getstarted() {
    if (!this.custom.valid) {
      this.custom.markAllAsTouched();
      return;
    }

    this.isScheduleMeetSubmitted = true;

    const url = `${this.stateService.apiList.user.approvalV3}`;

    this.stateService.addCalledApi(url);
    let payload = this.custom.value;
    payload["zone_id"] = payload["zone"];
    delete payload["zone"];
    this.httpService.postNewsletter(url, payload).subscribe(
      (val) => {
        if (val.status == "200" || val.status == "201") {
          this.successMessage = "LANDING.MESSAGES.ONBOARDING_REQUEST_SUCCESS";
          this.isSuccessMessage = true;
        }
        this.stateService.removeCalledApi(url);
      },
      (err) => {
        this.isSuccessMessage = true;
        if (err.error.message == "You are already onboarded") {
          this.successMessage = "LANDING.MESSAGES.ALREADY_ONBOARDED";
        } else if (err.error.message == "Please enter a valid email") {
          this.successMessage = "LANDING.MESSAGES.INVALID_EMAIL";
        } else {
          this.successMessage = err.error.message;
        }

        this.stateService.removeCalledApi(url);
      }
    );
  }

  startBannerTextAnimation() {
    setInterval(() => {
      this.animationIndex++;
      if (this.animationIndex == this.groups.length) this.animationIndex = 0;
    }, this.delay);
  }

  onLanguageChange(languageCode: string) {
    if (!languageCode) {
      return;
    }

    const selectedLanguage = this.languageList.find(
      (item) => item.language === languageCode
    );

    if (!selectedLanguage) {
      return;
    }

    this.selectedLanguageCode = selectedLanguage.language;
    this.selectedLanguage = selectedLanguage.label;
    this.translate.use(selectedLanguage.language);
    localStorage.setItem("appLanguage", JSON.stringify(selectedLanguage));
  }

  private initializeLanguage() {
    let selectedLanguage = this.languageList[0];
    const localLanguage = localStorage.getItem("appLanguage");

    if (localLanguage) {
      try {
        const parsedLanguage = JSON.parse(localLanguage);
        const languageCode =
          typeof parsedLanguage === "string"
            ? parsedLanguage
            : parsedLanguage?.language;
        const matchedLanguage = this.languageList.find(
          (item) => item.language === languageCode
        );

        if (matchedLanguage) {
          selectedLanguage = matchedLanguage;
        }
      } catch (_error) {
        selectedLanguage = this.languageList[0];
      }
    } else if (this.translate.currentLang) {
      const matchedLanguage = this.languageList.find(
        (item) => item.language === this.translate.currentLang
      );
      if (matchedLanguage) {
        selectedLanguage = matchedLanguage;
      }
    }

    this.selectedLanguageCode = selectedLanguage.language;
    this.selectedLanguage = selectedLanguage.label;
    this.translate.use(selectedLanguage.language);
    localStorage.setItem("appLanguage", JSON.stringify(selectedLanguage));
  }
}
